<script>
import { PUBLIC_DOMAIN, PUBLIC_FOOTER_COPYRIGHT } from "$env/static/public";

import { m } from "$lib/paraglide/messages.js";
</script>

<!-- FooterCopyright -->
<div class="flex flex-col items-center gap-1">
  <!-- <a
    href="/"
    class="text-high-contrast flex-none text-xl font-semibold focus:outline-none"
    aria-label="{PUBLIC_SITE_NAME}">{PUBLIC_SITE_NAME}</a
  > -->
  <p class="text-center text-sm whitespace-pre-line text-high-contrast opacity-75">
    {PUBLIC_FOOTER_COPYRIGHT} - {m.all_rights_reserved()}
  </p>
  <slot />
  <p class="text-center text-sm whitespace-pre-line text-high-contrast opacity-75">
    {PUBLIC_DOMAIN}
  </p>
</div>
<!-- End FooterCopyright -->
